import React from "react";
import { useNavigate } from "react-router-dom";
import SectionHeader from "./SectionHeader";

const urls = {
  setup: [
    { key: "knowledge-sources", name: "Knowledge Sources" },
    { key: "branding", name: "Branding" },
    { key: "intents", name: "Intents" },
    { key: "chatbot", name: "Test" },
    { key: "deploy", name: "Deploy" },
    { key: "share", name: "Share" },
  ],
  settings: [
    { key: "company_info", name: "Company" },
    { key: "add_team", name: "Team" },
    { key: "manage_billing", name: "Billing" },
    { key: "plans", name: "Plans" },
  ],
};

const GeneralSetupTab = ({ title, subtitle, pageType, activeTab }) => {
  const navigate = useNavigate();

  const setActiveTab = newTab => {
    if (newTab === activeTab) return;

    if (pageType === "setup") {
      navigate(`/setup/${newTab}`);
    } else {
      navigate(`/settings/${newTab}`);
    }
  };
  return (
    <div>
      <SectionHeader title={title} description={subtitle} />
      <div className="my-8">
        <nav className="flex space-x-1 sm:space-x-4 border-b-2 text-xs sm:text-base overflow-x-auto">
          {urls[`${pageType}`].map((setupObj, index) => (
            <button
              key={index}
              className={`font-semibold px-3 py-2 rounded-md ${activeTab === setupObj.key ? "text-primary border-b-2 border-primary rounded-none" : "text-gray-500"}`}
              onClick={() => setActiveTab(setupObj.key)}
            >
              {setupObj.name}
            </button>
          ))}
        </nav>
      </div>
    </div>
  );
};

export default GeneralSetupTab;
